import $$ from 'cmn-utils'
import leader from "./leader"

const baseUrl = "/api/sys/unit/v2/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    getDetail: (params) => {
        return $$.get(baseUrl + 'get-detail', params)
    },
    list: (params) => {
        Object.keys(params).map(key => {
            if (!params[key] || params[key] == 'null' || params[key] == 'undefined') delete params[key]
        })

        return $$.get(baseUrl + 'list', params)
    },
    listCategoryUnit: (params) => {
        return $$.get(baseUrl + 'list-category-unit', params)
    },
    listMap: (params) => {
        return $$.get(baseUrl + 'list-map', params)
    },
    tree: (params) => {
        Object.keys(params).map(key => {
            if (!params[key] || params[key] == 'null' || params[key] == 'undefined') delete params[key]
        })

        return $$.get(baseUrl + 'tree', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    leader
}
